import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';

// kakao map api 사용하기
declare var kakao: any;

@Component({
  selector: 'np-kakao-map',
  standalone: true,
  imports: [],
  templateUrl: './np-kakao-map.component.html',
  styleUrl: './np-kakao-map.component.scss'
})
export class NpKakaoMapComponent implements OnInit {

  // 페이지 초기화 여부
  npInited: boolean = false;

  // @ViewChild('kakaoMap', { static: false }) private kakaoMapRef: ElementRef;

  kakaoMap: any;
  drawRunning: any;

  @Input()
  options: any;
  @Input()
  markers: any;
  @Input()
  customOverlays: any;
  @Input()
  rectangles: any;
  @Input()
  clusterer: any;
  @Input()
  polylines: any;
  @Input()
  bounds: any;
  @Input()
  showDelay: number = 300;
  @Input()
  infoWindows: any;

  @Output() mapInited = new EventEmitter<any>();

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   if (this.npInited && this.kakaoRef) {
  //     // this.kakaoMap.relayout();
  //     // console.log('aaa');
  //   }
  // }

  constructor(private renderer: Renderer2, private el: ElementRef) {
  }

  ngOnInit(): void {
    this.draw();
    this.npInited = true;
  }

  ngOnChanges() {
    if (this.npInited) {
      this.draw();
    }
  }

  public draw() {

    if (!this.options) {
      this.options = {
        //지도를 생성할 때 필요한 기본 옵션
        center: new kakao.maps.LatLng(37.56669, 126.97842), //지도의 중심좌표.
        level: 7 //지도의 레벨(확대, 축소 정도)
      };
    }

    if (this.drawRunning) {
      clearTimeout(this.drawRunning);
    }

    this.drawRunning = setTimeout(this.showMap, this.showDelay);
  }

  kakaoRef!: ElementRef;

  showMap = () => {

    if (this.kakaoRef) {
      this.renderer.removeChild(this.el.nativeElement, this.kakaoRef);
    }

    this.kakaoRef = this.renderer.createElement('div');
    this.renderer.addClass(this.kakaoRef, 'np-kakaomap');
    this.renderer.appendChild(this.el.nativeElement, this.kakaoRef);

    this.kakaoMap = new kakao.maps.Map(this.kakaoRef, this.options); //지도 생성 및 객체 리턴

    if (this.markers && this.markers.length > 0) {
      for (let idx in this.markers) {
        let marker = this.markers[idx];

        if (!marker.npHidden) {
          marker.setMap(this.kakaoMap);
        }
      }
    }

    if (this.customOverlays && this.customOverlays.length > 0) {
      for (let idx in this.customOverlays) {
        let customOverlay = this.customOverlays[idx];

        if (!customOverlay.npHidden) {
          customOverlay.setMap(this.kakaoMap);
        }
      }
    }

    if (this.rectangles && this.rectangles.length > 0) {
      for (let idx in this.rectangles) {
        let rectangle = this.rectangles[idx];

        if (!rectangle.npHidden) {
          rectangle.setMap(this.kakaoMap);
        }
      }
    }

    if (this.polylines && this.polylines.length > 0) {
      for (let idx in this.polylines) {
        const polyline = this.polylines[idx];

        if (!polyline.npHidden) {
          polyline.setMap(this.kakaoMap)
        }
      }
    }

    if (this.clusterer) {
      this.clusterer.setMap(this.kakaoMap);
    }

    if (this.bounds && this.bounds.isEmpty() === false) {
      this.kakaoMap.setBounds(this.bounds);
    }

    if (this.infoWindows && this.infoWindows.length > 0) {
      for (let idx in this.infoWindows) {
        let infoWindow = this.infoWindows[idx];
        infoWindow.setMap(this.kakaoMap);
      }
    }

    this.mapInited.emit(this.kakaoMap);

  }
}
